<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="题目分类：">
        <el-select v-model="query.type" placeholder="请选择" clearable size="small">
          <el-option label="考试闯关" :value="1"></el-option>
          <el-option label="学习闯关" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="考试时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import courseSubjectBarrierRecordsApi from '@/api/course/courseSubjectBarrierRecords'
export default {
  props: ['isIntegral'],
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
        type: undefined
      },
      topicClassOptions: [],
    }
  },
  created() {
  },
  methods: {
    handleDownload() {
      this.query.createdTimeStart = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      this.query.createdTimeEnd = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined

      return this.$common.confirm('是否确认导出')
        .then(() => courseSubjectBarrierRecordsApi.exportExcel2(this.query)).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 500)

          }
        })
    },

  }

}
</script>

<style>
</style>